'use strict';

import { Helper } from '../helpers/Helper.js';
export class Tooltip {
	#tooltips = {};

	hideDelay = 100; // delay in ms
	animationDelay = 300; //delay in ms

	constructor() {
		this.#addEvents();
	}

	#addEvents() {
		document.addEventListener('mouseover', event => {
			if (event.target.matches('[data-lev-tooltip]') || event.target.closest('[data-lev-tooltip]')) {
				const item = event.target.matches('[data-lev-tooltip]') ? event.target : event.target.closest('[data-lev-tooltip]');

				let uniqueID = item.dataset?.levTooltipId;

				if (!uniqueID){
					uniqueID = Helper.uniqueID(8);
					item.dataset.levTooltipId = uniqueID;
					this.#tooltips[uniqueID] = this.newTooltip(item, uniqueID);
				} else {
					this.stayOn(item, uniqueID);
				}
			} else if (event.target.matches('.levcharity_tooltip') || event.target.closest('.levcharity_tooltip')) {
				const toolTip = event.target.matches('.levcharity_tooltip') ? event.target : event.target.closest('.levcharity_tooltip');
				let uniqueID = toolTip.dataset?.levTooltipId;

				const item = document.querySelector(`[data-lev-tooltip][data-lev-tooltip-id="${uniqueID}"]`);

				this.stayOn(item, uniqueID);
			}
		});

		document.addEventListener('mouseout', event => {
			if (event.target.matches('[data-lev-tooltip]') || event.target.closest('[data-lev-tooltip]')) {
				const item = event.target.matches('[data-lev-tooltip]') ? event.target : event.target.closest('[data-lev-tooltip]');

				let uniqueID = item.dataset?.levTooltipId;

				this.startRemoveCountdown(item, uniqueID);
			} else if (event.target.matches('.levcharity_tooltip') || event.target.closest('.levcharity_tooltip')) {
				const toolTip = event.target.matches('.levcharity_tooltip') ? event.target : event.target.closest('.levcharity_tooltip');
				let uniqueID = toolTip.dataset?.levTooltipId;

				const item = document.querySelector(`[data-lev-tooltip][data-lev-tooltip-id="${uniqueID}"]`);

				this.startRemoveCountdown(item, uniqueID);
			}
		});

		window.addEventListener('resize', () => this.#handleWindowResize());
		window.addEventListener('orientationchange', () => this.#handleWindowResize());
	}

	#handleWindowResize() {
		for (const uniqueID in this.#tooltips) {
			if (this.#tooltips.hasOwnProperty(uniqueID)) {
				const { item, element } = this.#tooltips[uniqueID];
				this.updateTooltipPosition(item, element);
			}
		}
	}

	newTooltip(item, uniqueID) {
		let content = item.dataset.levTooltip;
		const element = document.createElement('div');
		element.classList.add('levcharity_tooltip');
		element.classList.add('invisible');
		element.dataset.levTooltipId = uniqueID;

		const caret = document.createElement('span');
		caret.classList.add('levcahrity_tooltip_caret');

		const contentElement = document.createElement('div');
		contentElement.classList.add('levcharity_tooltip_content');
		contentElement.innerHTML = content;

		element.append(caret);
		element.append(contentElement);
		document.body.append(element);

		this.updateTooltipPosition(item, element);
		this.updateTooltipPosition(item, element);
		setTimeout(() => {
			element.classList.remove('invisible');
			this.updateTooltipPosition(item, element);
		}, 100);

		return {
			element,
			timeout: null,
			removeTimeout: null,
		}
	}

	stayOn(item, uniqueID) {
		const data = this.#tooltips[uniqueID];

		if (data?.timeout){
			clearTimeout(data.timeout);
		}
		if (data?.removeTimeout){
			data.element.classList.remove('fade-out');
			clearTimeout(data.removeTimeout);
		}
	}

	startRemoveCountdown(item, uniqueID) {
		const data = this.#tooltips[uniqueID];

		this.stayOn(item, uniqueID);

		data.timeout = setTimeout(() => {
			this.removeTooltip(item, uniqueID);
		}, this.hideDelay);

		this.#tooltips[uniqueID] = data;
	}

	removeTooltip(item, uniqueID) {
		const data = this.#tooltips[uniqueID];

		data.element.classList.add('fade-out');

		data.removeTimeout = setTimeout(() => {
			data.element.remove();
			delete this.#tooltips[uniqueID];
			delete item.dataset.levTooltipId;
		}, this.animationDelay + 50);

		this.#tooltips[uniqueID] = data;
	}

	updateTooltipPosition(item, element) {
		let rect = item.getBoundingClientRect();
		let top = rect.top + window.scrollY,
			left = rect.left + window.scrollX;

		let itemWidth = item.offsetWidth;
		let itemHeight = item.offsetHeight;
		let elementWidth = element.offsetWidth;
		let elementHeight = element.offsetHeight;

		let place = item.dataset?.levTooltipPosition || 'vertical';

		let elementTop = 0;
		let elementLeft = 0;

		let caretTop = 0;
		let caretLeft = 0;

		const scrollWidth = document.documentElement.scrollWidth;
		const scrollHeight = document.documentElement.scrollHeight;

		element.classList.remove('place-top')
		element.classList.remove('place-bottom')
		element.classList.remove('place-left')
		element.classList.remove('place-right')

		if (place === 'vertical') {
			elementTop = top + itemHeight + 12;
			elementLeft = itemWidth > elementWidth ? left + (itemWidth / 2 - elementWidth / 2) : left - ((elementWidth - itemWidth) / 2);
			caretLeft = elementWidth / 2 - 9.5;

			if (elementLeft + elementWidth >= scrollWidth) {
				elementLeft = scrollWidth - elementWidth - 5;
				caretLeft = elementWidth - itemWidth / 2 - 19 - 5;
			} else if (elementLeft <= 0) {
				elementLeft = 5;
				caretLeft = itemWidth / 2 - 19 + left + elementLeft
			}

			if (elementTop + elementHeight >= scrollHeight) {
				elementTop = elementTop - itemHeight - elementHeight - 12;
				element.classList.add('place-top')
			} else {
				element.classList.add('place-bottom')
			}
		} else if (place === 'horizontal') {
			elementTop = itemHeight > elementHeight ? top + (itemHeight / 2 - elementHeight / 2) : top - ((elementHeight - itemHeight) / 2);
			elementLeft = left + itemWidth + 12;
			caretLeft = -8;
			caretTop = elementHeight / 2 - 8.5;

			if (elementTop + elementHeight + 5 >= scrollHeight) {
				elementTop = scrollHeight - elementHeight - 11;
				caretTop = elementHeight - 5 - 19;
			} else if (elementTop <= 0) {
				elementTop = 5;
				caretTop = 24;
			}

			if (elementLeft + elementWidth >= scrollWidth) {
				elementLeft = elementLeft - itemWidth - elementWidth - 24;
				element.classList.add('place-left')
			} else {
				element.classList.add('place-right')
			}
		}

		element.style.setProperty('--top', elementTop + 'px');
		element.style.setProperty('--left', elementLeft + 'px');

		element.style.setProperty('--caret-left', caretLeft + 'px')
		element.style.setProperty('--caret-top', caretTop + 'px')
	}
}
